<svelte:options tag="fdk-scheduling-form" />

<script type="ts">
  import { onMount } from 'svelte'
  import type { Appointment } from './SchedulingFormCommon'

  export let apiurl = 'http://localhost:3000/api.php'
  export let disclaimerurl = 'http://www.fdk-nienburg.de/'
  export let disclaimerrequired = false

  let errored = false
  let succeeded = false
  let appointments: Appointment[] = []
  let firstname = ''
  let lastname = ''
  let email = ''
  let phone = ''
  let note = ''
  let password = ''
  let appointmentId = 0
  let loading = false
  let disclaimer = false

  let valid: boolean
  $: valid =
    !!firstname.trim() &&
    !!lastname.trim() &&
    !!email.trim() &&
    !!firstname.trim() &&
    !!phone.trim() &&
    !!appointmentId &&
    !password.trim() &&
    (disclaimerrequired ? disclaimer : true)

  const handleSubmit = async () => {
    loading = true
    try {
      await fetch(apiurl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          firstname,
          lastname,
          email,
          phone,
          note,
          id: appointmentId
        })
      })
      succeeded = true
    } catch {
      errored = true
    } finally {
      loading = false
    }
  }

  onMount(async () => {
    loading = true
    try {
      appointments = (
        await (
          await fetch(apiurl, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          })
        ).json()
      ).appointments
      if (appointments.length) {
        appointmentId = appointments[0].id
      }
    } catch (e) {
      console.error('Error while connecting API-URL: ', e)
      errored = true
    } finally {
      loading = false
    }
  })
</script>

<div class="wrapper">
  {#if !loading}
    <form on:submit|preventDefault={() => valid && !loading && handleSubmit()}>
      <div class="form-container">
        <input name="firstname" type="text" bind:value={firstname} placeholder="Vorname" />
        <input name="lastname" type="text" bind:value={lastname} placeholder="Nachname" />
        <input name="email" type="email" bind:value={email} placeholder="E-Mail" />
        <input name="phone" type="tel" bind:value={phone} placeholder="Telefon" />
        <input class="password" tabindex="-1" name="password" type="password" bind:value={password} />

        <select name="appointment" bind:value={appointmentId} disabled={!appointments.length}>
          {#if !appointments.length}
            <option value={0} disabled selected>Keine Termine vorhanden</option>
          {:else}
            {#each appointments as appointment}
              <option value={appointment.id}>
                {new Date(appointment.dateTime).toLocaleString('de-DE', {
                  weekday: 'short',
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit'
                })} Uhr
              </option>
            {/each}
          {/if}
        </select>
        {#if disclaimerrequired}
          <div class="disclaimer">
            <input type="checkbox" on:change={() => (disclaimer = !disclaimer)} />
            <label for="disclaimer">
              Die Daten werden zum Zweck der Terminvereinbarung verwendet. {#if !!disclaimerurl}(<a
                  href={disclaimerurl}
                  target="_blank">Unsere Datenschutzerklärung</a
                >){/if}
            </label>
          </div>
        {/if}

        <div class="footer">
          <button disabled={!valid || loading} type="submit">Reservieren</button>
        </div>
      </div>
    </form>
  {/if}
  {#if errored}
    <div class="error">Es ist ein Fehler aufgetreten</div>
  {/if}

  {#if succeeded}
    <div class="success">Vielen Dank für die Reservierung. <br /> Sie erhalten in Kürze eine Bestätigungsemail.</div>
  {/if}
</div>

<style lang="scss">
  @import '../../global.scss';
</style>
